module.exports = __webpack_public_path__ + "static/media/Android_O_01.193c9bbb.png";


//////////////////
// WEBPACK FOOTER
// ./src/Comp/img/Android_O_01.png
// module id = 93
// module chunks = 0